import React from 'react';

const Flow: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ・初回相談（無料）',
      icon: 'ri-chat-3-line',
      description: '電話、メール、LINEでお問い合わせください。初回相談は無料です。',
      details: [
        '現在の状況をお伺いします',
        '共有者の人数、関係性を確認',
        '不動産の概要を把握',
        '最適な解決方法をご提案'
      ]
    },
    {
      number: '02',
      title: '状況の調査・方針の決定',
      icon: 'ri-search-line',
      description: 'ご依頼いただいた場合、詳細な調査を行い、具体的な方針を決定します。',
      details: [
        '登記簿謄本の取得・確認',
        '共有者の確定（相続人調査）',
        '不動産の評価',
        '解決方針の決定と費用の確定'
      ]
    },
    {
      number: '03',
      title: '共有者との交渉・手続きの実施',
      icon: 'ri-discuss-line',
      description: '弁護士が代理人として、共有者との交渉や法的手続きを進めます。',
      details: [
        '共有者への連絡・交渉',
        '遺産分割協議書の作成',
        '売却条件の調整',
        '必要に応じて訴訟提起'
      ]
    },
    {
      number: '04',
      title: '処分完了',
      icon: 'ri-checkbox-circle-line',
      description: '売却または持分の処分が完了し、共有状態から解放されます。',
      details: [
        '売買契約の締結',
        '所有権移転登記',
        '代金の受領',
        '固定資産税の負担から解放'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            解決までの流れ
          </h2>
          <p className="text-xl text-gray-600">
            初回相談から処分完了まで、一貫してサポートします
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* 接続線 */}
              {index < steps.length - 1 && (
                <div className="absolute left-10 top-24 w-0.5 h-full bg-gradient-to-b from-orange-300 to-orange-200 z-0"></div>
              )}

              <div className="relative z-10 mb-8">
                <div className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-orange-300 hover:shadow-xl transition-all duration-200">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 mr-6">
                      <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center text-white shadow-lg">
                        <i className={`${step.icon} text-3xl`}></i>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center mb-3">
                        <span className="text-5xl font-bold text-orange-500 opacity-20 mr-4">
                          {step.number}
                        </span>
                        <h3 className="text-2xl font-bold text-gray-900">
                          {step.title}
                        </h3>
                      </div>
                      <p className="text-gray-700 text-lg leading-relaxed mb-6">
                        {step.description}
                      </p>
                      <div className="bg-gray-50 rounded-lg p-6">
                        <div className="grid md:grid-cols-2 gap-3">
                          {step.details.map((detail, idx) => (
                            <div key={idx} className="flex items-start">
                              <i className="ri-check-line text-orange-500 text-xl mr-2 mt-0.5"></i>
                              <span className="text-gray-700">{detail}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 p-8 bg-orange-50 rounded-2xl max-w-4xl mx-auto border-2 border-orange-200">
          <p className="text-xl font-bold text-gray-900 mb-3">
            期間の目安
          </p>
          <p className="text-gray-700 leading-relaxed">
            <strong>交渉による解決：</strong> 3ヶ月〜6ヶ月<br />
            <strong>訴訟による解決：</strong> 6ヶ月〜1年<br />
            ※ケースにより異なります
          </p>
        </div>
      </div>
    </section>
  );
};

export default Flow;
